<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t(`tlt.${moduleName}.add`)}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.administration')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="`/master/${moduleName}`">
              <span>{{$t(`tlt.${moduleName}`)}}</span>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item">
            <router-link :to="`/master/${moduleName}/edit`">
              <span>{{$t(`tlt.${moduleName}.new`)}}</span>
            </router-link>
          </li> -->
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList(moduleName)"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" @click="save">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <mmf-edit :entity="moduleName" ref="edit"></mmf-edit>
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="card my-1">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <location-calender></location-calender>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LocationCalender from "@/views/master/shift/LocationCalender";
import MmfEdit from "@/components/MmfEdit";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      moduleName: "teamShift"
    };
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
    save() {
      // 使用 edit 中的 save 而不是直接使用 MMFSave 的原因是
      // 为了触发保存时参数校验的回调函数
      this.$refs.edit.save();
    }
  },
  components: {
    LocationCalender,
    MmfEdit
  }
};
</script>

